/** Detect Next.js / webpack chunk load failures after deploy or stale tabs. */
export function isChunkLoadError(error: unknown): boolean {
  if (!error) return false;
  const message =
    error instanceof Error
      ? error.message
      : typeof error === "string"
        ? error
        : "";
  const name = error instanceof Error ? error.name : "";
  return (
    name === "ChunkLoadError" ||
    /Failed to load chunk|Loading chunk \d+ failed|ChunkLoadError/i.test(message)
  );
}
